import { Component, computed, input, output } from '@angular/core';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';
import { CardUIType, LMS_PLATFORM_LABELS, PlaylistCardShort } from '@app/app/shared/models';
import { LinkSquare02Icon } from '@hugeicons/core-free-icons/index';

@Component({
  selector: 'ptl-card-item-list-view',
  templateUrl: './card-item-list-view.component.html',
  styleUrls: ['./card-item-list-view.component.scss'],
})
export class CardItemListViewComponent {
  protected readonly LinkSquare02Icon = LinkSquare02Icon;

  card = input<PlaylistCardShort>();
  cardType = input<CardUIType>('general');
  cardIndex = input(0);
  showMeta = input(true);
  showReviews = input(true);
  showProgressLine = input(true);

  cardClick = output<PlaylistCardShort>();

  cardSubheader = computed(() => {
    const card = this.card();
    return card?.subHeader ? LanguageCodeHelper.getDataByLanguageCode(card.subHeader).value.trim() : '';
  });

  lmsPlatformLabel = computed(() => {
    const platformType = this.card()?.lmsPlatformType;
    return platformType ? LMS_PLATFORM_LABELS[platformType] || platformType : '';
  });

  onCardClick(): void {
    const card = this.card();
    if (card?.lmsCourseUrl) {
      window.open(card.lmsCourseUrl, '_blank', 'noopener,noreferrer');
    }
    this.cardClick.emit(card);
  }
}
